import React, { useState, useEffect, useRef } from "react";
import "./chart.css";
import bottleImage from "../../../assets/chart-2-ii.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = '37%';
              setWaterPercentage(waterHeight);
            }, 300);

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="chart-section" ref={chartSectionRef}>
      <div className="trust-data-container-2">
        <div className="trust-data2">
          <img className="trust-data-image" src={bottleImage} alt="Bottle" />
          <div
            className="trust-data-water2"
            style={{ height: waterPercentage }}
          />
        </div>
      </div>
    </div>
  );
};

export default Chart;
